module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab142-6b07285f1f37aa7e87454775cbe99406.jpg";